import React from 'react'

const Manual_admin_crear_clientes = () => {
  return (
    <>
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
        <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Admin - Crear Clientes
        </h2>
        <p className="text-lg text-gray-700 mb-6">
        Esta guía ofrece un proceso sencillo para crear clientes dentro del sistema, detallando los pasos
        necesarios y los tipos de clientes que puede registrar. Ayuda a los usuarios a comprender las diferencias entre
        los distintos tipos de clientes y la información específica requerida para cada uno, garantizando una entrada
        de datos precisa. Siguiendo esta guía, los usuarios pueden configurar clientes y gestionar opciones de crédito
        de forma eficiente, optimizando así sus capacidades administrativas.
        </p>
        <iframe
        src="https://scribehow.com/embed/Admin__Crear_Clientes__slMnlU47SQCUDi3ptGSJWA?as=scrollable"
        className="scribe-iframe-general-19"
        width="100%"
        height="5500"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
        ></iframe>
        </div>
    </div>
    </>
  )
}

export default Manual_admin_crear_clientes